import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import Vant from 'vant';
import 'vant/lib/index.css';
// 引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.use(Vant);

// swiper-bundle.min.css 决定了小圆点和左右翻页标签，如果不需要可以不引用
import "swiper/swiper-bundle.min.css";

// px转rem
// import './config/rem'
import 'lib-flexible'

// 样式重写
import "@/asstes/style/reset.css"

import config from './config/index'
import http from './utils/http'
import utils from "./utils/utils";
import server from './utils/server';

// 测试控制台
// import VConsole from 'vconsole';
// new VConsole({maxLogNumber:1000});

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import moment from 'moment'//导入文件
Vue.prototype.$moment = moment;//赋值使用

Vue.prototype.$A = config;
Vue.prototype.$H = http;
Vue.prototype.$U = utils
Vue.config.productionTip = false

new Vue({
    router,
    store,
    server,
    render: h => h(App)
}).$mount('#app')
